import { Empty } from 'antd';
import Modal from 'antd/es/modal/Modal';
import React from 'react';

const RiderLocationModal = ({
  isLocationModalVisible,
  setIsLocationModalVisible,
  delivery,
  latitude,
  longitude,
}) => (
  <div>
    <Modal
      title={`Live Location: ${delivery?.firstName || ''} ${
        delivery?.lastName || ''
      }`}
      open={isLocationModalVisible}
      onCancel={() => setIsLocationModalVisible(false)}
      footer={null}
      width={800}
      destroyOnClose
    >
      {latitude && longitude ? (
        <>
          <p>
            Last Update: {new Date().toLocaleTimeString()} (Next refresh in 30s)
          </p>
          <iframe
            title="Live Location"
            width="100%"
            height="450"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
          />
        </>
      ) : (
        <Empty description="No live location data available." />
      )}
    </Modal>
  </div>
);

export default RiderLocationModal;
